<template>
  <div class="drawer">
    <div v-if="display" class="maskClass" @click="closeMask"></div>
    <div :style="mainStyle" class="main">
      <div class="drawer-head">
        <span class="d_title">{{ title }} <i v-if="setIcon" class="el-icon-setting" @click="settingMask"></i></span>
        <i class="el-icon-close close-btn" @click="closeMask"></i>
      </div>
      <div class="drawer-body" :style="status == 'service' ? 'height: calc(100% - 136px);' : ''">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 是否打开
    display: {
      type: Boolean
    },
    displaySet: {
      type: Boolean
    },
    setIcon: {
      type: Boolean,
      default: false
    },
    // 标题
    title: {
      type: String,
      default: '标题'
    },
    // 状态
    status: {
      type: String,
      default: ''
    },
  },
  computed: {
    mainStyle() {
      return {
        right: this.display ? '0' : '-420px',
        // right: this.displaySet ? '0' : `-420px`
      };
    }
  },
  methods: {
    closeMask() {
      this.$emit('update:display', false);
    },
    settingMask() {
      console.log('----');
      this.$emit('update:displaySet', true);
    },
  }
};
</script>
<style>
.drawer .main {
  height: calc(100% - 80px);
}
.drawer .drawer-body {
  height: calc(100% - 62px);
}
.drawer .drawer-body::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #f5f5f5;
}

.drawer .drawer-body::-webkit-scrollbar-track-piece {
  background-color: #fff;
}

.drawer .drawer-body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.drawer .drawer-body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #999;
}
</style>
<style lang="less" scoped>
.drawer {
  width: 390px;
  clear: both;
  /* 遮罩 */
  .maskClass {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 8;
    background-color: rgba(0, 0, 0, 0);
    opacity: 1;
  }

  /* 滑块 */
  .main {
    position: fixed;
    z-index: 2001;
    width: 390px;
    bottom: 0;
    background: #fff;
    transition: all 0.5s;
    border-radius: 5px 0 0 5px;
    box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2),
      0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12);
    padding-bottom: 40px;
  }

  /* 其他样式 */
  .drawer-head {
    display: flex;
    justify-content: space-between;
    height: 19px;
    line-height: 19px;
    padding: 20px;
    .d_title {
      color: #333;
      font-size: 17px;
      font-weight: 600;
    }
    .close-btn {
      line-height: 19px;
      color: #a1a4a9;
      font-size: 14px;
      display: inline-block;
      cursor: pointer;
      height: 100%;
      padding-left: 20px;
    }
  }
  .drawer-body {
    padding: 0 20px;
    overflow-y: auto;
    overflow-x: hidden;
    .li {
      width: 100%;
      margin-bottom: 20px;
      .el-button {
        margin: 0 10px 10px 0 !important;
      }
      p {
        width: 100%;
        font-size: 16px;
        color: #333;
        height: 19px;
        line-height: 19px;
        margin-bottom: 10px;
        .el-button {
          margin: 0 !important;
        }
      }
      .input_small {
        width: 80px;
        float: left;
        font-size: 12px;
      }
      samp {
        float: left;
        font-size: 12px;
        line-height: 32px;
        padding: 0 10px;
      }
    }
    .li::after {
      display: table;
      content: "";
      clear: both;
    }
    .mb_10 {
      margin-bottom: 10px;
    }
    .li:nth-child(n + 4) {
      margin-bottom: 10px;
    }
    .dfoot {
      position: fixed;
      bottom: 0;
      width: 390px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      border-radius: 0 0 0 5px;
      text-align: center;
      cursor: pointer;
      z-index: 9;
      color: #fff;
      margin-left: -20px;
    }
    .drawer_foot {
      position: fixed;
      bottom: 0;
      width: 390px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      border-radius: 0 0 0 5px;
      text-align: center;
      cursor: pointer;
      z-index: 9;
      color: #fff;
      margin-left: -20px;
      box-sizing: border-box;
      display: flex;
      li {
        width: 50%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
    }
    .drawer_btn {
      background-color: #ffffff;
      border: solid 1px #d8dce5;
      font-size: 14px;
      color: #2d2f33;
    }
    .drawer_btn_tow {
      font-size: 14px;
      color: #fff;
    }
  }
}
</style>
